module.exports = __webpack_public_path__ + "static/media/vipps_logo_rgb.befa72a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/cases/vipps_logo_rgb.png
// module id = 376
// module chunks = 0